<app-window [title]="'Riepilogo'">   
    <div class="p-2">           
        <form role="form" id="detailForm" *ngIf="record">            
            <div class="row">
                <div class="col-lg-8">
                    <div class="form-group">
                        <label>Titolo</label>
                        <div class="input-group" >
                            <input class="form-control form-control-sm" type="text"  name="title"  [(ngModel)]="record.name"  />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <app-type [id_type]="record.id_type" [class]="" [table]="'dossier'" [record]="record" ></app-type>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Descrizione</label>
                        <div class="input-group" >
                            <textarea class="form-control form-control-sm" row="5" name="description"  [(ngModel)]="record.description" ></textarea>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="record.params">
                    <div class="col-12">
                        <div class="form-group">
                            <label>Query (riepilogo)</label>
                            <div class="input-group" >
                                <textarea class="form-control form-control-sm" row="5" name="params_query"  [(ngModel)]="record.params.query" ></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <label>Query (su selezione lista)</label>
                            <div class="input-group" >
                                <textarea class="form-control form-control-sm" row="5" name="params_query2"  [(ngModel)]="record.params.query2" ></textarea>
                            </div>
                        </div>
                    </div>
                </ng-container>
               <div class="col-4">
                    <div class="form-group">
                        <label>Ordinamento</label>
                        <div class="input-group" >
                            <input type="number" class="form-control form-control-sm"  name="ordering"  [(ngModel)]="record.ordering" >
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="form-group">
                        <label>Colore</label>
                        <div class="input-group" >
                            <select  class="form-control form-control-sm"  name="color" [(ngModel)]="record.color" >
                                <option value="lightblue">Azzurro</option>
                                <option value="white">Bianco</option>
                                <option value="bisque">Beige</option>                                
                                <option value="royalblue">Blu</option>
                                <option value="yellow">Giallo</option>
                                <option value="orangered">Arancione</option>
                                <option value="lightgreen">Verde</option>
                                <option value="violet">Viola</option>
                            </select>
                            <div class="input-group-append">
                                <span class="input-group-text" style="background-color: {{record.color}}"></span>
                              </div>
                        </div>
                    </div>
                </div>
            </div>          
        </form>       
    </div>
    <app-toolbarmodel [model]="this" [showSave]="true" [showSaveAndClose]="true"></app-toolbarmodel>
</app-window>